import { cn } from '@/lib/cn';

/**
 * The Break Point Club wordmark, rebuilt to match the brand logo: thin geometric
 * caps, with the "O" of POINT replaced by a red snooker ball, gold rules around
 * CLUB, and an optional SNOOKER CLUB subtitle. Vector/CSS so it stays crisp at
 * any size and follows the theme. Sizing flows from one container font-size.
 */
export function BrandMark({
  size = 'md',
  subtitle = false,
  className,
}: {
  size?: 'sm' | 'md' | 'lg';
  subtitle?: boolean;
  className?: string;
}) {
  const base = { sm: '0.95rem', md: '1.45rem', lg: '2.4rem' }[size];

  return (
    <div
      className={cn('inline-flex flex-col items-center font-sans font-light leading-none', className)}
      style={{ fontSize: base }}
      aria-label="Break Point Club"
    >
      <span className="tracking-[0.18em] text-content">BREAK</span>

      <span className="mt-[0.12em] inline-flex items-center tracking-[0.18em] text-content">
        P
        <span
          className="mx-[0.04em] inline-block rounded-full"
          style={{
            width: '0.82em',
            height: '0.82em',
            background:
              'radial-gradient(circle at 35% 30%, #ffffff 0%, #ff9a9a 16%, #d94b56 52%, #8f2530 100%)',
            boxShadow: 'inset 0 0 0 0.055em rgba(255,255,255,0.9)',
          }}
          aria-hidden="true"
        />
        INT
      </span>

      <span className="mt-[0.28em] flex w-full items-center gap-[0.4em]">
        <span className="h-px flex-1 bg-brand/45" />
        <span className="text-brand" style={{ fontSize: '0.46em', letterSpacing: '0.34em', paddingLeft: '0.34em' }}>
          CLUB
        </span>
        <span className="h-px flex-1 bg-brand/45" />
      </span>

      {subtitle && (
        <span
          className="mt-[0.35em] text-subtle"
          style={{ fontSize: '0.3em', letterSpacing: '0.42em', paddingLeft: '0.42em' }}
        >
          SNOOKER CLUB
        </span>
      )}
    </div>
  );
}
